import React from 'react';

import assets from 'config/_assets.json';
import constants from 'config/_constants.json';

function Logo() {
  return <img src={assets.sidebarLogo} alt={constants.COMPANY_NAME} style={{ objectFit: 'contain' }} />;
}

export default Logo;
